import type { MultilingualQuestion } from '../../types/multilingualQuestion';

// Multilingual version of Prohibitory Signs questions
export const prohibitorySignsMultilingual: MultilingualQuestion[] = [
  {
    id: 'q-ps-1',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-1o1',
        text: {
          en: 'Maximum speed 50 km/h',
          nl: 'Maximumsnelheid 50 km/u',
          ar: 'الحد الأقصى للسرعة 50 كم/س'
        }
      },
      {
        id: 'q-ps-1o2',
        text: {
          en: 'Speed limit ends',
          nl: 'Snelheidslimiet eindigt',
          ar: 'ينتهي حد السرعة'
        }
      },
      {
        id: 'q-ps-1o3',
        text: {
          en: 'Minimum speed 50 km/h',
          nl: 'Minimumsnelheid 50 km/u',
          ar: 'الحد الأدنى للسرعة 50 كم/س'
        }
      }
    ],
    correctAnswerId: 'q-ps-1o2',
    explanation: {
      en: 'This sign indicates the end of a previously imposed 50 km/h speed limit. National or other posted speed limits now apply.',
      nl: 'Dit bord geeft het einde aan van een eerder opgelegde snelheidslimiet van 50 km/u. Nationale of andere aangegeven snelheidslimieten gelden nu.',
      ar: 'تشير هذه العلامة إلى نهاية حد السرعة البالغ 50 كم/س الذي تم فرضه سابقا. الآن تنطبق حدود السرعة الوطنية أو المعلن عنها الأخرى.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-1.jpg',
    imageHint: 'speed limit ends'
  },
  {
    id: 'q-ps-2',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-2o1',
        text: {
          en: 'Vehicles weighing heavier than indicated forbidden',
          nl: 'Voertuigen zwaarder dan aangegeven verboden',
          ar: 'المركبات الأثقل من المحدد محظورة'
        }
      },
      {
        id: 'q-ps-2o2',
        text: {
          en: 'No entry for lorries',
          nl: 'Geen toegang voor vrachtwagens',
          ar: 'ممنوع الدخول للشاحنات'
        }
      },
      {
        id: 'q-ps-2o3',
        text: {
          en: 'Axle weight limit 5,4t',
          nl: 'Asgewichtlimiet 5,4t',
          ar: 'حد وزن المحور 5.4 طن'
        }
      }
    ],
    correctAnswerId: 'q-ps-2o1',
    explanation: {
      en: 'This sign prohibits vehicles with an actual weight exceeding 5,4 tonnes from proceeding.',
      nl: 'Dit bord verbiedt voertuigen met een werkelijke gewicht van meer dan 5,4 ton om door te gaan.',
      ar: 'تحظر هذه العلامة المركبات التي يزيد وزنها الفعلي عن 5.4 طن من المتابعة.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-2.jpg',
    imageHint: 'weight limit 5.4t'
  },
  {
    id: 'q-ps-3',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-3o1',
        text: {
          en: 'Agricultural vehicles route',
          nl: 'Route voor landbouwvoertuigen',
          ar: 'مسار المركبات الزراعية'
        }
      },
      {
        id: 'q-ps-3o2',
        text: {
          en: 'No entry for slow vehicles',
          nl: 'Geen toegang voor langzame voertuigen',
          ar: 'ممنوع الدخول للمركبات البطيئة'
        }
      },
      {
        id: 'q-ps-3o3',
        text: {
          en: 'Tractors prohibited',
          nl: 'Tractoren verboden',
          ar: 'الجرارات محظورة'
        }
      }
    ],
    correctAnswerId: 'q-ps-3o3',
    explanation: {
      en: 'This sign indicates that tractors and other specified agricultural vehicles are prohibited from this road.',
      nl: 'Dit bord geeft aan dat tractoren en andere gespecificeerde landbouwvoertuigen verboden zijn op deze weg.',
      ar: 'تشير هذه العلامة إلى أن الجرارات والمركبات الزراعية المحددة الأخرى محظورة على هذا الطريق.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-3.jpg',
    imageHint: 'no tractors'
  },
  {
    id: 'q-ps-4',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-4o1',
        text: {
          en: 'Cyclists not permitted',
          nl: 'Fietsers niet toegestaan',
          ar: 'راكبو الدراجات غير مسموحين'
        }
      },
      {
        id: 'q-ps-4o2',
        text: {
          en: 'Cycle route ahead',
          nl: 'Fietsroute vooruit',
          ar: 'مسار دراجات أمامك'
        }
      },
      {
        id: 'q-ps-4o3',
        text: {
          en: 'Shared path for pedestrians and cyclists',
          nl: 'Gedeeld pad voor voetgangers en fietsers',
          ar: 'مسار مشترك للمشاة وراكبي الدراجات'
        }
      }
    ],
    correctAnswerId: 'q-ps-4o1',
    explanation: {
      en: 'This sign means no entry for bicycles. Cyclists must find an alternative route.',
      nl: 'Dit bord betekent geen toegang voor fietsen. Fietsers moeten een alternatieve route vinden.',
      ar: 'تعني هذه العلامة عدم السماح بدخول الدراجات. يجب على راكبي الدراجات العثور على مسار بديل.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-4.jpg',
    imageHint: 'no cyclists'
  },
  {
    id: 'q-ps-5',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-5o1',
        text: {
          en: 'No parking zone',
          nl: 'Geen parkeerzone',
          ar: 'منطقة ممنوع الوقوف'
        }
      },
      {
        id: 'q-ps-5o2',
        text: {
          en: 'Stopping and parking forbidden',
          nl: 'Stoppen en parkeren verboden',
          ar: 'التوقف والوقوف محظوران'
        }
      },
      {
        id: 'q-ps-5o3',
        text: {
          en: 'Clearway, no stopping on carriageway',
          nl: 'Vrije baan, geen stoppen op de rijbaan',
          ar: 'طريق خال، ممنوع التوقف على الطريق'
        }
      }
    ],
    correctAnswerId: 'q-ps-5o2',
    explanation: {
      en: 'This sign indicates that stopping and parking are forbidden along this section of road.',
      nl: 'Dit bord geeft aan dat stoppen en parkeren verboden zijn langs dit deel van de weg.',
      ar: 'تشير هذه العلامة إلى أن التوقف والوقوف محظوران على طول هذا الجزء من الطريق.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-5.jpg',
    imageHint: 'no stopping parking'
  },
  {
    id: 'q-ps-6',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-6o1',
        text: {
          en: 'Speed limit 30 km/h applies',
          nl: 'Snelheidslimiet 30 km/u geldt',
          ar: 'ينطبق حد السرعة 30 كم/س'
        }
      },
      {
        id: 'q-ps-6o2',
        text: {
          en: 'End of all restrictions in zone',
          nl: 'Einde van alle beperkingen in zone',
          ar: 'نهاية جميع القيود في المنطقة'
        }
      },
      {
        id: 'q-ps-6o3',
        text: {
          en: 'End of the zone with speed limit',
          nl: 'Einde van de zone met snelheidslimiet',
          ar: 'نهاية المنطقة مع حد السرعة'
        }
      }
    ],
    correctAnswerId: 'q-ps-6o3',
    explanation: {
      en: 'This sign marks the end of a zone where a specific speed limit (e.g., 30 km/h) was in force.',
      nl: 'Dit bord markeert het einde van een zone waar een specifieke snelheidslimiet (bijv. 30 km/u) van kracht was.',
      ar: 'تحدد هذه العلامة نهاية منطقة كان فيها حد سرعة محدد (مثل 30 كم/س) ساريا.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-6.jpg',
    imageHint: 'end speed zone'
  },
  {
    id: 'q-ps-7',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-7o1',
        text: {
          en: 'Begin of a zone with speed limit',
          nl: 'Begin van een zone met snelheidslimiet',
          ar: 'بداية منطقة مع حد سرعة'
        }
      },
      {
        id: 'q-ps-7o2',
        text: {
          en: 'Residential area, walking speed',
          nl: 'Woonwijk, wandelsnelheid',
          ar: 'منطقة سكنية، سرعة المشي'
        }
      },
      {
        id: 'q-ps-7o3',
        text: {
          en: 'Recommended speed 30 km/h',
          nl: 'Aanbevolen snelheid 30 km/u',
          ar: 'السرعة الموصى بها 30 كم/س'
        }
      }
    ],
    correctAnswerId: 'q-ps-7o1',
    explanation: {
      en: 'This sign indicates the beginning of a zone where a specific speed limit (in this case, 30 km/h) applies.',
      nl: 'Dit bord geeft het begin aan van een zone waar een specifieke snelheidslimiet (in dit geval 30 km/u) geldt.',
      ar: 'تشير هذه العلامة إلى بداية منطقة ينطبق فيها حد سرعة محدد (في هذه الحالة 30 كم/س).'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-7.jpg',
    imageHint: 'begin speed zone 30'
  },
  {
    id: 'q-ps-8',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-8o1',
        text: {
          en: 'Overtaking permitted',
          nl: 'Inhalen toegestaan',
          ar: 'التجاوز مسموح'
        }
      },
      {
        id: 'q-ps-8o2',
        text: {
          en: 'End of the overtaking prohibition',
          nl: 'Einde van de inhaalverbod',
          ar: 'نهاية حظر التجاوز'
        }
      },
      {
        id: 'q-ps-8o3',
        text: {
          en: 'No overtaking by lorries',
          nl: 'Geen inhalen door vrachtwagens',
          ar: 'ممنوع التجاوز للشاحنات'
        }
      }
    ],
    correctAnswerId: 'q-ps-8o2',
    explanation: {
      en: 'This sign indicates the end of a previously imposed overtaking prohibition. Standard overtaking rules now apply.',
      nl: 'Dit bord geeft het einde aan van een eerder opgelegd inhaalverbod. Standaard inhaalregels gelden nu.',
      ar: 'تشير هذه العلامة إلى نهاية حظر التجاوز الذي تم فرضه سابقا. الآن تنطبق قواعد التجاوز القياسية.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-8.jpg',
    imageHint: 'end no overtaking'
  },
  {
    id: 'q-ps-9',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-9o1',
        text: {
          en: 'No entry for any vehicles',
          nl: 'Geen toegang voor voertuigen',
          ar: 'ممنوع الدخول لأي مركبات'
        }
      },
      {
        id: 'q-ps-9o2',
        text: {
          en: 'Cyclists, mopeds and tractors prohibited',
          nl: 'Fietsers, bromfietsen en tractoren verboden',
          ar: 'راكبو الدراجات والدراجات البخارية والجرارات محظورة'
        }
      },
      {
        id: 'q-ps-9o3',
        text: {
          en: 'Route for agricultural vehicles and cycles only',
          nl: 'Route alleen voor landbouwvoertuigen en fietsen',
          ar: 'مسار للمركبات الزراعية والدراجات فقط'
        }
      }
    ],
    correctAnswerId: 'q-ps-9o2',
    explanation: {
      en: 'This sign prohibits entry for cyclists, mopeds, and tractors.',
      nl: 'Dit bord verbiedt toegang voor fietsers, bromfietsen en tractoren.',
      ar: 'تحظر هذه العلامة دخول راكبي الدراجات والدراجات البخارية والجرارات.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-9.jpg',
    imageHint: 'no cyclists mopeds tractors'
  },
  {
    id: 'q-ps-10',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-10o1',
        text: {
          en: 'Motorcycles must use this lane',
          nl: 'Motorfietsen moeten deze rijstrook gebruiken',
          ar: 'يجب على الدراجات النارية استخدام هذا الممر'
        }
      },
      {
        id: 'q-ps-10o2',
        text: {
          en: 'Motorbikes - Motorcycles prohibited',
          nl: 'Motoren - Motorfietsen verboden',
          ar: 'الدراجات النارية محظورة'
        }
      },
      {
        id: 'q-ps-10o3',
        text: {
          en: 'Motorcycle parking area',
          nl: 'Motorfietsenstalling',
          ar: 'منطقة وقوف الدراجات النارية'
        }
      }
    ],
    correctAnswerId: 'q-ps-10o2',
    explanation: {
      en: 'This sign indicates that motorcycles (motorbikes) are prohibited from using this road or area.',
      nl: 'Dit bord geeft aan dat motorfietsen verboden zijn om deze weg of dit gebied te gebruiken.',
      ar: 'تشير هذه العلامة إلى أن الدراجات النارية محظورة من استخدام هذا الطريق أو المنطقة.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit-10.jpg',
    imageHint: 'no motorcycles'
  },
  {
    id: 'q-ps-11',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-11o1',
        text: {
          en: 'No parking',
          nl: 'Parkeren verboden',
          ar: 'ممنوع الوقوف'
        }
      },
      {
        id: 'q-ps-11o2',
        text: {
          en: 'No entry for motor vehicles',
          nl: 'Geen toegang voor motorvoertuigen',
          ar: 'ممنوع دخول المركبات الآلية'
        }
      },
      {
        id: 'q-ps-11o3',
        text: {
          en: 'No entry for cars',
          nl: 'Geen toegang voor auto\'s',
          ar: 'ممنوع دخول السيارات'
        }
      }
    ],
    correctAnswerId: 'q-ps-11o1',
    explanation: {
      en: 'This red circular sign with blue inner circle and diagonal line indicates that parking is prohibited in this area.',
      nl: 'Dit rode ronde bord met blauwe binnenkring en diagonale streep betekent dat parkeren in dit gebied verboden is.',
      ar: 'تشير هذه العلامة الدائرية الحمراء ذات الدائرة الزرقاء الداخلية والخط القطري إلى أن الوقوف محظور في هذه المنطقة.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-1.png',
    imageHint: 'no parking'
  },
  {
    id: 'q-ps-12',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-12o1',
        text: {
          en: 'Entry not allowed / forbidden (checkpoint)',
          nl: 'Geen toegang / verboden (controlepost)',
          ar: 'دخول غير مسموح / ممنوع (نقطة تفتيش)'
        }
      },
      {
        id: 'q-ps-12o2',
        text: {
          en: 'No entry for motor vehicles',
          nl: 'Geen toegang voor motorvoertuigen',
          ar: 'ممنوع دخول المركبات الآلية'
        }
      },
      {
        id: 'q-ps-12o3',
        text: {
          en: 'No entry for cars',
          nl: 'Geen toegang voor auto\'s',
          ar: 'ممنوع دخول السيارات'
        }
      }
    ],
    correctAnswerId: 'q-ps-12o1',
    explanation: {
      en: 'This red circular sign with horizontal bar indicates that entry is not allowed or forbidden, often used at checkpoints or restricted areas.',
      nl: 'Dit rode ronde bord met horizontale balk betekent dat doorgang niet is toegestaan of verboden is, vaak bij controleposten of verboden gebieden.',
      ar: 'تشير هذه العلامة الدائرية الحمراء ذات الشريط الأفقي إلى أن الدخول غير مسموح أو ممنوع، غالباً عند نقاط التفتيش أو المناطق المحظورة.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-2.png',
    imageHint: 'entry not allowed forbidden checkpoint'
  },
  {
    id: 'q-ps-13',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-13o1',
        text: {
          en: 'Overtaking not allowed',
          nl: 'Inhalen niet toegestaan',
          ar: 'التجاوز غير مسموح'
        }
      },
      {
        id: 'q-ps-13o2',
        text: {
          en: 'No entry for motor vehicles',
          nl: 'Geen toegang voor motorvoertuigen',
          ar: 'ممنوع دخول المركبات الآلية'
        }
      },
      {
        id: 'q-ps-13o3',
        text: {
          en: 'No entry for cars',
          nl: 'Geen toegang voor auto\'s',
          ar: 'ممنوع دخول السيارات'
        }
      }
    ],
    correctAnswerId: 'q-ps-13o1',
    explanation: {
      en: 'This red circular sign with two vehicles facing each other indicates that overtaking is not allowed on this road.',
      nl: 'Dit rode ronde bord met twee tegenover elkaar gerichte voertuigen betekent dat inhalen op deze weg niet is toegestaan.',
      ar: 'تشير هذه العلامة الدائرية الحمراء التي تعرض مركبتين باتجاهين إلى أن التجاوز غير مسموح على هذا الطريق.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-3.png',
    imageHint: 'overtaking not allowed'
  },
  {
    id: 'q-ps-14',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-14o1',
        text: {
          en: 'Height restriction ahead',
          nl: 'Hoogtebeperking vooruit',
          ar: 'قيود الارتفاع أمامك'
        }
      },
      {
        id: 'q-ps-14o2',
        text: {
          en: 'Height limit 3.1m',
          nl: 'Hoogte maximaal 3,1 m',
          ar: 'حد الارتفاع 3.1 م'
        }
      },
      {
        id: 'q-ps-14o3',
        text: {
          en: 'Low bridge ahead',
          nl: 'Lage brug vooruit',
          ar: 'جسر منخفض أمامك'
        }
      }
    ],
    correctAnswerId: 'q-ps-14o1',
    explanation: {
      en: 'This sign indicates a height restriction ahead. Vehicles exceeding the specified height are prohibited from using this road or area.',
      nl: 'Dit bord geeft een hoogtebeperking vooruit aan. Voertuigen die hoger zijn dan aangegeven mogen deze weg of dit gebied niet gebruiken.',
      ar: 'تشير هذه العلامة إلى قيود الارتفاع أمامك. تُحظر مركبات يتجاوز ارتفاعها القيمة المحددة من استخدام هذا الطريق أو المنطقة.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-4.png',
    imageHint: 'height restriction ahead'
  },
  {
    id: 'q-ps-15',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-15o1',
        text: {
          en: 'No turning / u-turn allowed',
          nl: 'Keren en omkeren verboden',
          ar: 'منع الدوران أو الاستدارة'
        }
      },
      {
        id: 'q-ps-15o2',
        text: {
          en: 'U-turn permitted',
          nl: 'Omkeren toegestaan',
          ar: 'الاستدارة مسموحة'
        }
      },
      {
        id: 'q-ps-15o3',
        text: {
          en: 'Turn around ahead',
          nl: 'Keer om hier vooruit',
          ar: 'استدر أمامك'
        }
      }
    ],
    correctAnswerId: 'q-ps-15o1',
    explanation: {
      en: 'This red circular sign with a white U-turn arrow indicates that turning and U-turns are not allowed at this location.',
      nl: 'Dit rode ronde bord met een witte U-pijl betekent dat keren en omkeren op deze plek niet is toegestaan.',
      ar: 'تشير هذه العلامة الدائرية الحمراء مع سهم استدارة بيضاء إلى أن الدوران واستدارة الاتجاه غير مسموحين هنا.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-5.png',
    imageHint: 'no turning u-turn allowed'
  },
  {
    id: 'q-ps-16',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-16o1',
        text: {
          en: 'Vehicles - Cars prohibited',
          nl: 'Voertuigen — auto\'s verboden',
          ar: 'مركبات — سيارات ممنوعة'
        }
      },
      {
        id: 'q-ps-16o2',
        text: {
          en: 'No entry for cars',
          nl: 'Geen toegang voor auto\'s',
          ar: 'ممنوع دخول السيارات'
        }
      },
      {
        id: 'q-ps-16o3',
        text: {
          en: 'Motor vehicle route',
          nl: 'Route voor motorvoertuigen',
          ar: 'مسار للمركبات الآلية'
        }
      }
    ],
    correctAnswerId: 'q-ps-16o1',
    explanation: {
      en: 'This red circular sign with a car silhouette indicates that vehicles, specifically cars, are prohibited from using this road or area.',
      nl: 'Dit rode ronde bord met een auto-silhouet betekent dat voertuigen, met name auto\'s, deze weg of dit gebied niet mogen gebruiken.',
      ar: 'تشير هذه العلامة الدائرية الحمراء ذات شكل سيارة إلى أن المركبات، وخصوصاً السيارات، محظورة من استخدام هذا الطريق أو المنطقة.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-6.png',
    imageHint: 'vehicles cars prohibited'
  },
  {
    id: 'q-ps-17',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-17o1',
        text: {
          en: 'Speed limit',
          nl: 'Snelheidslimiet',
          ar: 'حد السرعة'
        }
      },
      {
        id: 'q-ps-17o2',
        text: {
          en: 'Maximum speed 50 km/h',
          nl: 'Maximumsnelheid 50 km/u',
          ar: 'الحد الأقصى للسرعة 50 كم/س'
        }
      },
      {
        id: 'q-ps-17o3',
        text: {
          en: 'Speed limit ends',
          nl: 'Einde snelheidslimiet',
          ar: 'انتهاء حد السرعة'
        }
      }
    ],
    correctAnswerId: 'q-ps-17o1',
    explanation: {
      en: 'This red circular sign with a number indicates a speed limit that must not be exceeded on this road.',
      nl: 'Dit rode ronde bord met een getal geeft een snelheidslimiet aan die op deze weg niet overschreden mag worden.',
      ar: 'تشير هذه العلامة الدائرية الحمراء ذات الرقم إلى حد سرعة لا يجوز تجاوزه على هذا الطريق.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-7.png',
    imageHint: 'speed limit'
  },
  {
    id: 'q-ps-18',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-18o1',
        text: {
          en: 'Vehicles with dangerous goods prohibited',
          nl: 'Voertuigen met gevaarlijke stoffen verboden',
          ar: 'مركبات تحمل بضائع خطيرة ممنوعة'
        }
      },
      {
        id: 'q-ps-18o2',
        text: {
          en: 'Lorry route',
          nl: 'Route voor vrachtwagens',
          ar: 'مسار الشاحنات'
        }
      },
      {
        id: 'q-ps-18o3',
        text: {
          en: 'Lorry parking area',
          nl: 'Parkeergebied voor vrachtwagens',
          ar: 'منطقة وقوف للشاحنات'
        }
      }
    ],
    correctAnswerId: 'q-ps-18o1',
    explanation: {
      en: 'This red circular sign with a symbol for dangerous goods indicates that vehicles carrying dangerous goods are prohibited from using this road or area.',
      nl: 'Dit rode ronde bord met symbool voor gevaarlijke stoffen betekent dat voertuigen met gevaarlijke lading deze weg of dit gebied niet mogen gebruiken.',
      ar: 'تشير هذه العلامة الدائرية الحمراء ذات رمز البضائع الخطيرة إلى أن المركبات التي تنقل مواد خطرة محظورة من استخدام هذا الطريق أو المنطقة.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-8.png',
    imageHint: 'vehicles dangerous goods prohibited'
  },
  {
    id: 'q-ps-19',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-19o1',
        text: {
          en: 'End of the overtaking prohibition for trucks',
          nl: 'Einde verbod op inhalen voor vrachtwagens',
          ar: 'نهاية حظر التجاوز للشاحنات'
        }
      },
      {
        id: 'q-ps-19o2',
        text: {
          en: 'Motor vehicle route',
          nl: 'Route voor motorvoertuigen',
          ar: 'مسار للمركبات الآلية'
        }
      },
      {
        id: 'q-ps-19o3',
        text: {
          en: 'Motor vehicle parking area',
          nl: 'Parkeergebied voor motorvoertuigen',
          ar: 'منطقة وقوف للمركبات الآلية'
        }
      }
    ],
    correctAnswerId: 'q-ps-19o1',
    explanation: {
      en: 'This sign indicates the end of the overtaking prohibition for trucks. After this sign, trucks are no longer prohibited from overtaking.',
      nl: 'Dit bord geeft het einde aan van het inhalingsverbod voor vrachtwagens. Na dit bord mogen vrachtwagens weer inhalen.',
      ar: 'تشير هذه العلامة إلى نهاية حظر التجاوز للشاحنات. بعد هذه العلامة لم يعد تجاوز الشاحنات محظوراً.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-9.png',
    imageHint: 'end overtaking prohibition trucks'
  },
  {
    id: 'q-ps-20',
    text: {
      en: 'Identify the road sign:',
      nl: 'Identificeer het verkeersbord:',
      ar: 'حدد علامة الطريق:'
    },
    options: [
      {
        id: 'q-ps-20o1',
        text: {
          en: 'Mopeds prohibited',
          nl: 'Bromfietsen verboden',
          ar: 'الدراجات البخارية الخفيفة محظورة'
        }
      },
      {
        id: 'q-ps-20o2',
        text: {
          en: 'Moped route',
          nl: 'Route voor bromfietsen',
          ar: 'مسار للدراجات البخارية'
        }
      },
      {
        id: 'q-ps-20o3',
        text: {
          en: 'Moped parking area',
          nl: 'Parkeergebied voor bromfietsen',
          ar: 'منطقة وقوف للدراجات البخارية'
        }
      }
    ],
    correctAnswerId: 'q-ps-20o1',
    explanation: {
      en: 'This sign indicates that mopeds are prohibited from using this road or area.',
      nl: 'Dit bord geeft aan dat bromfietsen deze weg of dit gebied niet mogen gebruiken.',
      ar: 'تشير هذه العلامة إلى أن الدراجات البخارية الخفيفة محظورة من استخدام هذا الطريق أو المنطقة.'
    },
    subject: 'Prohibitory Signs',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/q-prohibit2-10.png',
    imageHint: 'mopeds prohibited'
  },
  {
    id: 'q-ps-21',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/signs/prohibitory/parking-1-no-parking-sign.jpg',
    text: {
      en: 'What does the "No Parking" sign indicate?',
      nl: 'Wat geeft het "Parkeren verboden" bord aan?',
      ar: 'ماذا تشير علامة "ممنوع الوقوف" إليه؟'
    },
    options: [
      {
        id: 'q-ps-21o1',
        text: {
          en: 'Parking is allowed but only for 1 hour',
          nl: 'Parkeren is toegestaan maar alleen voor 1 uur',
          ar: 'يسمح بالوقوف لكن فقط لمدة ساعة واحدة'
        }
      },
      {
        id: 'q-ps-21o2',
        text: {
          en: 'Parking is absolutely prohibited in this area',
          nl: 'Parkeren is absoluut verboden in dit gebied',
          ar: 'يحظر الوقوف بشكل مطلق في هذه المنطقة'
        }
      },
      {
        id: 'q-ps-21o3',
        text: {
          en: 'Parking is allowed but only for residents',
          nl: 'Parkeren is toegestaan maar alleen voor inwoners',
          ar: 'يسمح بالوقوف لكن فقط للمقيمين'
        }
      }
    ],
    correctAnswerId: 'q-ps-21o2',
    explanation: {
      en: 'The "No Parking" sign (red circle with white X) prohibits parking absolutely in the marked area. Vehicles found parked here will be subject to fines and possible removal. (RVV 1990 art. 12)',
      nl: 'Het "Parkeren verboden" bord (rode cirkel met witte X) verbiedt parkeren absoluut in het gemarkeerde gebied. Voertuigen die hier geparkeerd worden aangetroffen, kunnen onder boete en mogelijke verwijdering vallen. (RVV 1990 art. 12)',
      ar: 'علامة "ممنوع الوقوف" (دائرة حمراء بعلامة X بيضاء) تحظر الوقوف بشكل مطلق في المنطقة المحددة. المركبات التي تترك متوقفة هنا قد تخضع لغرامات وإزالة محتملة. (RVV 1990 art. 12)'
    },
    subject: 'Prohibitory Signs'
  }
];

























